import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'Assessment/src/components/ui/alert-dialog';
import { Button } from 'Assessment/src/components/ui/button';

interface RerecordWarningDialogProps {
  open: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const RerecordWarningDialog = ({ open, onCancel, onContinue }: RerecordWarningDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className='text-lg'>Last Attempt</AlertDialogTitle>
          <AlertDialogDescription className='text-lg'>
            This is your last attempt. You can only record one more time before the practice automatically moves to the next phase.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {/* <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction asChild onClick={onContinue}>
            <Button size="lg">Continue to Re-record</Button>
          </AlertDialogAction>
        </AlertDialogFooter> */}
 <AlertDialogFooter className="mt-6 justify-end pr-14">
  <AlertDialogCancel className='text-lg' onClick={onCancel}>
    Cancel
  </AlertDialogCancel>

  <AlertDialogAction className='text-lg' asChild onClick={onContinue}>
    <Button size="lg">Continue to Re-record</Button>
  </AlertDialogAction>
</AlertDialogFooter>

      </AlertDialogContent>
    </AlertDialog>
  );
};
